import { Text } from '@percent/lemonade'
import type { GivingCampaignOverviewDto } from '@percent/workplace-giving/api/campaigns/campaign.types'
import { SearchResultCardLayout } from '@percent/workplace-giving/common/components/SearchResultCardLayout/SearchResultCardLayout'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

export function GivingCampaignGroupItemCard({
  campaignOverview
}: {
  campaignOverview: GivingCampaignOverviewDto
}): JSX.Element {
  return (
    <SearchResultCardLayout
      title={campaignOverview.title}
      linkTo={AppRoute.CAMPAIGN.replace(':campaignId', campaignOverview.id)}
      image={campaignOverview.coverImage}
    >
      <Text as="p" size="small" color="rgba(var(--gray600))">
        {campaignOverview.shortDescription}
      </Text>
    </SearchResultCardLayout>
  )
}
